<template>
  <div>
	  	<header class="app-header navbar" v-if="$route.path !== '/login' && $route.path !== '/otp' && $route.path !== '/register'">
	  		<span class="navbar-brand" to="/"></span>
		    <ul class="nav navbar-nav">
		    	<li class="nav-item dropdown px-1" id="hk-logo">
		    		<span href="" class="nav-link logo-link" style="color: #fff;font-weight: 700;font-style: italic;">
		    			<img src="/static/images/icons/hongkong.png" class="iconx backlogicon" style="width: 60px;height: 50px;">
		    			 Hong Kong
		    		</span> 
		    	</li>

		      <span v-if="$root.userRole === 'admin' || $root.userRole === 'purchaser' || $root.userRole === 'qc' || $root.userRole === 'r_and_d' || $root.userRole === 'client' || $root.userRole === 'client_p' || $root.userRole === 'hq_top' || $root.userRole === 'hq_warehouse'">

		      	<template v-if="$root.userRole !== 'client' && $root.userRole !== 'qc'">
			      <li class="nav-item dropdown px-1">
		       			<a href="" class="nav-link dropdown-toggle active" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
		       			<img class="iconx backlogicon" src="/static/images/icons/icon-backlog.png"/> Backlog</a>
		                <div class="dropdown-menu dropdown-menu-right">

		                	<router-link class="dropdown-item" to="/backlog"> 
		                		<img class="iconx backlogicon" src="/static/images/icons/backlog.png"/> Backlog
		                	</router-link>

		                    <router-link v-if="$root.userRole == 'admin'" target="_blank" class="dropdown-item" to="/backlog/sales-order/add">
		                    	<img class="iconx backlogicon" src="/static/images/icons/cashback.svg"/> New Sales Order
		                    </router-link>

		                    <a v-if="$root.userRole != 'client_p' && $root.userRole != 'hq_top' && $root.userRole != 'r_and_d' && $root.userRole != 'hq_warehouse'" href="#" class="dropdown-item" @click="showPurchaseOrderModal = true">
		                    	<img class="iconx backlogicon" src="/static/images/icons/bill.png"/> 
		                    	New Purchase Order
		                    </a>

		                    <router-link v-if="$root.userRole != 'client_p' && $root.userRole != 'hq_top' && $root.userRole != 'r_and_d' && $root.userRole != 'hq_warehouse'" target="_blank" class="dropdown-item" to='/payment-plan/add'>
								<img class="iconx backlogicon" src="/static/images/icons/dollar2.png"/> 
								Payment Plan Submission
							</router-link>

		                    <router-link v-if="$root.userRole != 'client_p' && $root.userRole != 'hq_top' && $root.userRole != 'r_and_d' && $root.userRole != 'hq_warehouse'" target="_blank" class="dropdown-item" to='/arrival-details/add'>
								<img class="iconx backlogicon" src="/static/images/icons/delivery-box.png"/> 
								Arrival Details Submission
							</router-link>

		                    <a v-if="$root.user_role == 'admin' || $root.userRole == 'client_p' || $root.userRole == 'hq_top'" href="#" class="dropdown-item" @click="showHqDeliveryDateChangeModal = true">
		                    	<img class="iconx backlogicon" src="/static/images/icons/clock.png"/> 
		                    Change HQ delivery date</a>
		                </div>
			       </li>
				</template>
		       <li v-if="$root.userRole != 'hq_warehouse'" class="nav-item dropdown px-1">
		       			<a href="" class="nav-link dropdown-toggle nav-link" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
		       			<img class="iconx inventoryicon" src="/static/images/icons/icon-inventory.png"/>Inventory</a>
		                <div class="dropdown-menu dropdown-menu-right">
		                    <router-link class="dropdown-item" to="/items">
		                    <img src="/static/images/icons/item.png" class="iconx backlogicon"> Items</router-link>
		                    <router-link class="dropdown-item" to="/quotations" v-if="!$root.isClient && !$root.isHqTop && !$root.isRandD && !$root.isQc">
		                    <img src="/static/images/icons/dollar.png" class="iconx backlogicon"> Quotations</router-link>
		                    <router-link class="dropdown-item" to="/vendors">
		                    <img src="/static/images/icons/vendor.png" class="iconx backlogicon"> Vendors</router-link>

							<template v-if="!$root.isPurchaser && !$root.isQc  && !$root.isRandD">
								<router-link class="dropdown-item" to="/client/commercial-offers" v-if="$root.isClient || $root.isHqTop">
			                    <img src="/static/images/icons/business.png" class="iconx backlogicon"> Commercial Offers</router-link>	
			                    <router-link class="dropdown-item" to="/auth-commercial-offers" v-else>
			                    <img src="/static/images/icons/business.png" class="iconx backlogicon"> Commercial Offers</router-link>		
			                </template>
			                <router-link v-if="!$root.isRandD" class="dropdown-item" to="/qr-management">
		                    <img src="/static/images/icons/quality_assurance.png" class="iconx backlogicon"> QR Management</router-link>                       
		                </div>
		       </li>				
				<li class="nav-item px-1" v-if="$root.userRole === 'admin' || $root.userRole === 'supervisor' || $root.userRole === 'client' || $root.userRole === 'client_p'  || $root.userRole === 'purchaser' || $root.userRole === 'qc' || $root.userRole === 'r_and_d' || $root.userRole === 'hq_top'">
					<router-link class="nav-link" to="/samples-documents"><img class="iconx documentsicon" src="/static/images/icons/icon-documents.png"/> Documents/Samples/RFQ</router-link>
				</li>		

				<li class="nav-item dropdown px-1">
		       			<a href="" v-if="$root.user.user_type === 'admin' || $root.isHqTop" class="nav-link dropdown-toggle nav-link" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
		       			<img class="iconx accounticon" src="/static/images/icons/icon-system.png"/>System</a>
		                <div class="dropdown-menu dropdown-menu-right">
		                    <router-link class="dropdown-item" to="/users">
		                    	<img class="iconx usericon" src="/static/images/icons/user.png"/> User Management
							</router-link>
		                    <template v-if="$root.anAdmin">
		                    	<router-link class="dropdown-item" to="/clients">
		                    	<img class="iconx usericon" src="/static/images/icons/costumer.png"/> Clients</router-link>
		                    </template>     
							<template v-if="$root.anAdmin">
		                    	<router-link class="dropdown-item" to="/settings">
		                    	<img class="iconx usericon" src="/static/images/icons/settings.png"/> Settings</router-link>
		                    </template>                   
		                </div>
		         </li>
				<li class="nav-item px-1" v-if="$root.anAdmin || $root.userRole === 'auditor'">
					<router-link class="nav-link" to="/documents-archive"><img class="iconx documentsicon" src="/static/images/icons/document-archive.png"/> Documents Archive</router-link>
				</li>	

		    </span>
		    <span v-else>
		        <li v-if="$root.isCommercialOffer()" class="nav-item px-1">
		          <router-link class="nav-link" to="/buyersheet"><i aria-hidden="true" class="fa fa-shopping-cart"></i> Buyer Sheet</router-link>
		        </li>
		    </span>
		    </ul>
			<ul v-if="$route.path  != '/commercial-offers'" class="nav navbar-nav pull-right">
				<li class="nav-item">
					<a class="nav-link" href="javascript:void(0)" style="margin-right: 20px;">Welcome <b>{{ $root.userName }}</b>!</a>
				</li>
		    	<li class="nav-item dropdown px-1">
			        <a class="nav-link dropdown-toggle nav-link" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">
			            <span class="d-md-down-none"><i class="icon-user icons"></i></span>
			        </a>
			        <div class="dropdown-menu dropdown-menu-right">
						<router-link v-if="$root.anAdmin" class="dropdown-item" to="/change-password">
							<i class="fa fa-lock"></i> Change Password
						</router-link>
			            <a class="dropdown-item" href="#" @click="logout"><i class="fa fa-lock"></i> Logout</a>
			        </div>
		       	</li>
			</ul>
			<ul v-if="$route.path  == '/commercial-offers'" class="nav navbar-nav pull-right">
				<li class="nav-item px-1">
			        <a class="nav-link" href="/#login">Login</a>
		     	</li>
			</ul>
	  	</header>
	  	<modal v-if="showPurchaseOrderModal" @close="showPurchaseOrderModal = false">
		    <h5 slot="header" style="margin-bottom:0">New Purchase Order Registration</h5>
		    <div slot="body">
		      <purchase-order></purchase-order>
		    </div>
		    <span slot="support"></span>
		</modal>
		<modal class="hq-delivery-date-change" v-if="showHqDeliveryDateChangeModal" @close="showHqDeliveryDateChangeModal = false">
		    <div slot="header" style="margin-bottom:0">
		    	<h5>
		    		<img src="/static/images/icons/clock.png" class="image-50"/>
		    		<b>HQ delivery date change registration</b>
		    	</h5>
		    </div>
		    <div slot="body">
		      <hq-delivery-date-change></hq-delivery-date-change>
		    </div>
		    <span slot="support"></span>
		</modal>
	</div>
</template>

<script>
	import PurchaseOrderForm from './popup-forms/purchase-order.vue'
	import HqDeliveryDateChangeForm from './popup-forms/hq-delivery-date-change.vue'
	import Modal from './Modal.vue'

	export default {
		data: function(){
    		return {
    			showPurchaseOrderModal: false,
    			showHqDeliveryDateChangeModal: false
    		}
	    },
	    methods: {
	        logout() {
	            this.$http.post(process.env.API_ENDPOINT + '/user/logout?token=' + this.$cookies.get('teltonika_session')).then((response) => {
	                // response
	            }, (response) => {
	                // fail
	            })
	            this.$cookies.remove('teltonika_session')
				this.$cookies.remove('teltonika_verified')
	            this.$cookies.remove('teltonika_session_content')
	            this.$router.go('/login')
	        }
	    },
	    components: {
          Modal,
          'purchase-order': PurchaseOrderForm,
          'hq-delivery-date-change': HqDeliveryDateChangeForm
      	},
	    
	}
</script>


// WEBPACK FOOTER //
// Header.vue?7a86f294